import { render, staticRenderFns } from "./pdf-viewer.html?vue&type=template&id=f38a1cf0&scoped=true&"
import script from "./pdf-viewer.js?vue&type=script&lang=js&"
export * from "./pdf-viewer.js?vue&type=script&lang=js&"
import style0 from "./pdf-viewer.scss?vue&type=style&index=0&id=f38a1cf0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38a1cf0",
  null
  
)

export default component.exports